import { PerformanceTeamReview } from '../models/performance-team-review.model';

export class AddPerformanceTeamReviews {
    static readonly type = '[PerformanceTeamReview] AddPerformanceTeamReviews';

    constructor(public payload: PerformanceTeamReview[]) {}
}
